module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-LightItalic.4580f61.ttf";